// importing react componet
import * as React from 'react';

// importing react-redux component
import { connect } from 'react-redux';

// dev extreme grid component
import {
  SearchState,
  FilteringState,
  IntegratedFiltering,
  PagingState,
  SortingState,
  CustomPaging,
  IntegratedPaging,
  IntegratedSorting
} from '@devexpress/dx-react-grid';

// dev extreme paper (like canvas for rendering grid)
import Paper from '@material-ui/core/Paper';

// dev extreme grid UI
import {
  Grid,
  Table,
  Toolbar,
  SearchPanel,
  TableHeaderRow,
  TableColumnResizing,
  TableFilterRow,
  PagingPanel,
  TableColumnVisibility,
  ColumnChooser
} from '@devexpress/dx-react-grid-material-ui';

// importing api link 
import * as  apiService from '../../store/apiService'

// importing react routing link component
import { Link } from 'react-router-dom';

// header
import Header from '../../sharedcomponents/header';

// importing moment for date picket
import * as moment from 'moment';

import formatDate from '../../helpers/dateFormat';

// importing react date picker
import DatePicker from 'react-datepicker';

// importing date sorting helper
import { sortDatebySelection, sortString } from '../../helpers/sortingHelper';


import "react-datepicker/dist/react-datepicker-cssmodules.css";

// loading
import { Loader } from '../../sharedcomponents/loader';

// actions
import {
  fetchsubscriptionReports,
  fetchDatebyDateChange,
  filterExpiredUsers
} from '../../store/subscriptionReports/actions'

// logout
import { logout } from '../../store/login/action'

// importing column
import { subscriptionReportsColumns } from './subscriptionReportsColumns';

// Defining custom cell for Grid
// ts-ingore user for ignoring ts validation for perticular line

// enabling the functionality for display Header name when hover on column header 
// @ts-ignore
const ColumnHeaderCell = ({ getMessage, column, ...restProps }) => (
  // @ts-ignore
  <TableHeaderRow.Cell
    column={column}
    getMessage={() => column.title}
    {...restProps}
  />
);

// opening new tab in atlas with property number
function handleClickPropNum(args: any) {
  window.open(apiService.atlaslink(args), "_blank")
}

// @ts-ignore
const Cell = ({ value, ...restProps }) => {
  const { column } = restProps;
  if (column.name === "dsi_notes") {
    return <td><div className="word-breakdiv">{restProps.row.dsi_notes}</div></td>
  }
 
  if (column.name === 'prop_num') {
    return <td className="text-center" style={{ width: '10px' }}> <a style={{ color: 'lightblue' }} onClick={() => handleClickPropNum(restProps.row.prop_num)}>{restProps.row.prop_num}</a></td>
  }
  else {
    // @ts-ignore
    return (<Table.Cell {...restProps}>
      <span title={value}>{value}</span>
    </Table.Cell>)
  }
}


// hiding extra cell created due to empty column
const StubRow = (props: any) => (
  <Table.StubRow {...props} className="hide-stub" />
)

// hiding extra column header created due to empty column
const StubHeader = (props: any) => (
  <Table.StubHeaderCell {...props} className="hide-stub" />
)

// class
class subscriptionReports extends React.PureComponent<any, any>  {
  public changeCurrentPage: any; public changePageSize: any;

  // initializing constructor
  constructor(props: any) {
    super(props);

    // initializing state
    this.state = {
      route: '',
      date: '',
      selectedReport: 'allUsers',
      columns: [],
      ExpiredUsers_all_fees: false,
      ExpiredUsers_no_fees: false,
      ExpiredUsers_all: true,
      selectedFilterType: 'all',
      selectedMonth: 'all',
      selectedYear: 'all',
      tableColumnExtensions: subscriptionReportsColumns.tableAlignColumnExtensions,
      tableDetailColumnExtensions: subscriptionReportsColumns.tableDetailColumnExtensions, 
      rows: [],
      sorting: [{ columnName: 'prop_num', direction: 'asc' }],
      totalCount: 0,
      pageSize: 10,
      pageSizes: [10, 15, 30, 50],
      integratedSortingColumnExtensions: [
        { columnName: 'online_expires', compare: sortDatebySelection },
        { columnName: 'last_updated', compare: sortDatebySelection },
        { columnName: 'cancel_date', compare: sortDatebySelection },
        { columnName: 'user_name', compare: sortString },
        { columnName: 'property_name', compare: sortString }, 
        { columnName: 'dsi_notes', compare: sortString },
        { columnName: 'cancel_reason', compare: sortString },
        { columnName: 'cancel_notes', compare: sortString }
      ],
    };

    // binding public fuction to this
    this.changeCurrentPage = (currentPage: any) => this.setState({ currentPage });
    this.changePageSize = (pageSize: any) => this.setState({ pageSize });
    this.Sessionlogout = this.Sessionlogout.bind(this);
  }

  // method for handling logout button click
  public Sessionlogout() {
    this.props.dispatch(logout());
  }

  // first mathod will be called after page initialization
  public componentWillMount() {
    // initializing current route
    const route = location.hash;
    const getCurrentRoute = route.toString().split("/");
    const selectedReport = getCurrentRoute[2];
    this.setState({
      route: selectedReport,
      selectedReport: 'allUsers'
    })

    // calling get api for subscription report
    this.props.dispatch(fetchsubscriptionReports(selectedReport))
  }

  // first method will be called after reciveing any prop
  public componentWillReceiveProps(props: any) {
    const selectedRoute = this.state.route;
    const getCurrentRoute = selectedRoute.toString().split("/");
    const selectedReport = getCurrentRoute[0];
    this.setState({
      pageSize: 10,
      currentPage: 0,
    })

    // setting row and column date for selected subscription report
    if (selectedReport === 'allUsers') {
      if (props.AllUsers) {
        this.setState({
          rows: props.AllUsers,
          columns: subscriptionReportsColumns.allUsersColumns,
        
        })
      }
    }
    else if (selectedReport === 'archived') {
      if (props.Archived) {
        this.setState({
          rows: props.Archived,
          columns: subscriptionReportsColumns.archivedColumns,
         
          
        })
      }
    }
    else if (selectedReport === 'allUserNoRR') {
      if (props.AllUserNoRR) {
        this.setState({
          rows: props.AllUserNoRR,
          columns: subscriptionReportsColumns.allUsersNoRRColumns,
         
        })
      }
    }
    else if (selectedReport === 'allSubscriptions') {
      if (props.AllSubscriptions) {
        this.setState({
          rows: props.AllSubscriptions,
          columns: subscriptionReportsColumns.allSubscriptionsColumns,
            
        })
      }
    }
    else if (selectedReport === 'subscriptionsByDate') {
      if (props.SubscriptionsByDate) {
        this.setState({
          rows: props.SubscriptionsByDate,
          columns: subscriptionReportsColumns.subscriptionsByDateColumns,
          
        })
      }
    }
    else if (selectedReport === 'expiredUsers') {
      if (props.ExpiredUsers) {
        this.setState({
          rows: props.ExpiredUsers,
          columns: subscriptionReportsColumns.expiredUsersColumns,
         
        })
      }
    }
    else if (selectedReport === 'expiredIn30days') {
      if (props.ExpiredIn30Days) {
        this.setState({
          rows: props.ExpiredIn30Days,
          columns: subscriptionReportsColumns.expiredIn30DaysColumn,
         
        })
      }
    }
    else if (selectedReport === 'expiredIn120days') {
      if (props.ExpiredIn120Days) {
        this.setState({
          rows: props.ExpiredIn120Days,
          columns: subscriptionReportsColumns.expiredIn120DaysColumn,
         
        })
      }
    }
    else if (selectedReport === 'allTSLiveReport') {
      if (props.AllTSLiveReport) {
        this.setState({
          rows: props.AllTSLiveReport,
          columns: subscriptionReportsColumns.allTSLiveReportsColumns,
      
        })
      }
    }
    else if (selectedReport === 'specialBillingReports') {
      if (props.SpecialBillingReports) {
        this.setState({
          rows: props.SpecialBillingReports,
          columns: subscriptionReportsColumns.specialBillingReportsColumns,
        
        })
      }
    }
    else if (selectedReport === 'listOfIrvineAccounts') {
      if (props.ListOfIrvineAccounts) {
        this.setState({
          rows: props.ListOfIrvineAccounts,
          columns: subscriptionReportsColumns.irvineAccountsColumns,
        
        })
      }
    }
    else if (selectedReport === 'listOfRedyRefAccounts') {
      if (props.ListOfRedyRefAccounts) {
        this.setState({
          rows: props.ListOfRedyRefAccounts,
          columns: subscriptionReportsColumns.redyRefAccountsColumns,
        
        })
      }
    }
    else if (selectedReport === 'cancelledUsersReport') {
      if (props.CancelledUsersReport) {
        this.setState({
          rows: props.CancelledUsersReport,
          columns: subscriptionReportsColumns.canceledUsersReportsColumns,
         
        })
      }
    }
  }

  // method will be called after click on side navigation
  public onRouteChange(e: any) {
    const route = location.hash;
    const getCurrentRoute = route.toString().split("/")
    this.setState({
      route: getCurrentRoute[2],
      selectedReport: getCurrentRoute[2],
      filters: []
    })
    this.props.dispatch(fetchsubscriptionReports(getCurrentRoute[2]));
  }

  // method will be called after selecting expired user report toggle button
  public selectedFilter(type: any) {
    this.props.dispatch(filterExpiredUsers({ 'FilterType': type, 'SelectedMonth': this.state.selectedMonth, 'SelectedYear': this.state.selectedYear }))
    this.setState({
      selectedFilterType: type
    })
  }

  // method will be called when change in month dropdown in expired user report
  public getFilteredMonthParams(args: any) {
    if (args.target.value) {
      this.props.dispatch(filterExpiredUsers({ 'FilterType': this.state.selectedFilterType, 'SelectedMonth': args.target.value, 'SelectedYear': this.state.selectedYear }))
    }
    this.setState({
      selectedMonth: args.target.value
    })
  }

  // method will be called when chagne in year dropdown in expired user report
  public getFilteredYearParams(args: any) {
    if (args.target.value) {
      this.props.dispatch(filterExpiredUsers({ 'FilterType': this.state.selectedFilterType, 'SelectedMonth': this.state.selectedMonth, 'SelectedYear': args.target.value }))
    }
    this.setState({
      selectedYear: args.target.value
    })
  }

  // rendering UI
  public render() {
    const loading = this.props.loading ? <Loader /> : '';
    const { path } = this.props.match;
    const todayDate = new Date();
    const yearDropdown = []

    // generating year drop down with last 20 year
    const previousYears = todayDate.getFullYear() - 20;
    for (let i: any = previousYears; i <= todayDate.getFullYear(); i++) {
      yearDropdown.push(<option key={i} value={i}>{i}</option>)
    }

    // creating date picker component
    let datePickerComponent: any = "";
    datePickerComponent =
      this.state.route === "subscriptionsByDate" ?
        <div className="subscription_dateFilter"><span className="pull-left">Date : </span>
          <DatePicker
            className="pull-left"
            name="DisplayStart"
            selected={this.state.date ? moment(this.state.date, 'MM/DD/YYYY') : null}
            dateFormat="MM/DD/YYYY"
            onChange={(cdate: moment.Moment | null) => {
              const strDate = cdate && cdate.isValid() ? cdate.format() : '';
              this.setState({ date: formatDate(strDate) });
              this.props.dispatch(fetchDatebyDateChange(strDate))
            }
            }
            dropdownMode="select"
            showMonthDropdown={true}
            showYearDropdown={true}
          />
        </div>
        : "";

    // creating toggle, month and year component
    let toggleDiv: any = "";
    toggleDiv =
      this.state.route === "expiredUsers" ?
        <div>
          <div className="production-filter">
            <select onChange={(e) => {
            this.getFilteredYearParams(e)
          }} value={this.state.selectedYear} >
            <option value="all">All Years</option>
              {yearDropdown.reverse()}
            </select>
            <select onChange={(e) => {
            this.getFilteredMonthParams(e)
            }} value={this.state.selectedMonth} >
              <option value="all">All Months</option>
              <option value="0">January</option>
              <option value="1">February</option>
              <option value="2">March</option>
              <option value="3">April</option>
              <option value="4">May</option>
              <option value="5">June</option>
              <option value="6">July</option>
              <option value="7">August</option>
              <option value="8">September</option>
              <option value="9">October</option>
              <option value="10">November</option>
              <option value="11">December</option>
            </select>

            <ul>
              <li
                className={this.state.ExpiredUsers_all ? 'active' : ''}
                onClick={
                  (e) => {
                    this.selectedFilter("all")
                    this.setState({
                      ExpiredUsers_all: true,
                      ExpiredUsers_no_fees: false,
                      ExpiredUsers_all_fees: false,
                    });
                  }} >
                <Link to={`${path}/expiredUsers/`}>
                  All
                    </Link>
              </li>

              <li
                className={this.state.ExpiredUsers_no_fees ? 'active' : ''}
                onClick={
                  (e) => {
                    this.selectedFilter("no_fees")
                    this.setState({
                      ExpiredUsers_no_fees: true,
                      ExpiredUsers_all_fees: false,
                      ExpiredUsers_all: false,
                    });
                  }} >
                <Link to={`${path}/expiredUsers/`}>
                  No Fees
                    </Link>
              </li>

              <li
                className={this.state.ExpiredUsers_all_fees ? 'active' : ''}
                onClick={
                  (e) => {
                    this.selectedFilter("all_fees")
                    this.setState({
                      ExpiredUsers_all_fees: true,
                      ExpiredUsers_no_fees: false,
                      ExpiredUsers_all: false,
                    });
                  }} >
                <Link to={`${path}/expiredUsers/`}>
                  Fees Only
                    </Link>
              </li>
            </ul>
          </div>
        </div>
        : "";

    const {
      rows,
      columns,
      sorting,
      tableColumnExtensions,
      integratedSortingColumnExtensions,
      pageSize,
      pageSizes,
      currentPage,
      totalCount
    } = this.state;
   
    return (
      <div>
        {loading}
        <Header />
        <div className="header-bottom">
          <button
            className="btn right-float"
            onClick={() => this.Sessionlogout()}
          >Logout</button>
        </div>
        <div className="content-body">

        {/* Left navigation */}
          <div className="left-navigation">
            <ul>
              <li
                className={this.state.route === 'allUsers' ? 'active' : ''} onClick={(e) => this.onRouteChange(e)} >
                <Link to={`${path}/allUsers/`} className="active">
                  All Users
                            </Link>
              </li>
              <li
                className={this.state.route === 'archived' ? 'active' : ''} onClick={(e) => this.onRouteChange(e)}>
                <Link to={`${path}/archived/`} >
                  Archive
                            </Link>
              </li>
              <li
                className={this.state.route === 'allUserNoRR' ? 'active' : ''} onClick={(e) => this.onRouteChange(e)}>
                <Link to={`${path}/allUserNoRR/`} >
                  All Users - No RR
                            </Link>
              </li>
              <li
                className={this.state.route === 'allSubscriptions' ? 'active' : ''} onClick={(e) => this.onRouteChange(e)}>
                <Link to={`${path}/allSubscriptions/`} >
                  All Subscriptions
                            </Link>
              </li>
              <li
                className={this.state.route === 'subscriptionsByDate' ? 'active' : ''} onClick={(e) => this.onRouteChange(e)}>
                <Link to={`${path}/subscriptionsByDate/`}>
                  Subscriptions by date
                            </Link>
              </li>
              <li
                className={this.state.route === 'expiredUsers' ? 'active' : ''} onClick={(e) => this.onRouteChange(e)}>
                <Link to={`${path}/expiredUsers/`}>
                  Expired users
                            </Link>
              </li>
              <li
                className={this.state.route === 'expiredIn30days' ? 'active' : ''} onClick={(e) => this.onRouteChange(e)}>
                <Link to={`${path}/expiredIn30days/`}>
                  Expired In 30 Days
                            </Link>
              </li>
              <li
                className={this.state.route === 'expiredIn120days' ? 'active' : ''} onClick={(e) => this.onRouteChange(e)}>
                <Link to={`${path}/expiredIn120days/`}>
                  Expired In 120 Days
                            </Link>
              </li>
              <li
                className={this.state.route === 'allTSLiveReport' ? 'active' : ''} onClick={(e) => this.onRouteChange(e)}>
                <Link to={`${path}/allTSLiveReport/`}>
                  All TSLive Report
                            </Link>
              </li>
              <li
                className={this.state.route === 'specialBillingReports' ? 'active' : ''} onClick={(e) => this.onRouteChange(e)}>
                <Link to={`${path}/specialBillingReports/`}>
                  Special Billing report
                            </Link>
              </li>
              <li
                className={this.state.route === 'listOfIrvineAccounts' ? 'active' : ''} onClick={(e) => this.onRouteChange(e)}>
                <Link to={`${path}/listOfIrvineAccounts/`}>
                  List of Irvine Accounts
                                </Link>
              </li>
              <li
                className={this.state.route === 'listOfRedyRefAccounts' ? 'active' : ''} onClick={(e) => this.onRouteChange(e)}>
                <Link to={`${path}/listOfRedyRefAccounts/`}>
                  List of RedyRef Accounts
                                </Link>
              </li>
              <li
                className={this.state.route === 'cancelledUsersReport' ? 'active' : ''} onClick={(e) => this.onRouteChange(e)}>
                <Link to={`${path}/cancelledUsersReport/`}>
                  Cancelled users report
                                </Link>
              </li>
            </ul>
          </div>
          {this.props.loading ? '' :
            <div className="content-section">
              <div className="grid-style" id={`${this.state.route}-reports`}>
                {/* date picker */}
                {datePickerComponent}

              {/* drop down and button */}
              {toggleDiv}

              {/* main grid */}
              <Paper className="papergrid" style={{ position: 'relative' }}>
                <Grid
                  rows={rows}
                  columns={columns}
                >
                  <SearchState defaultValue="" />
                  <FilteringState
                   />
                  <IntegratedFiltering />

                  <SortingState
                    defaultSorting={sorting}
                  />
                  <IntegratedSorting
                    columnExtensions={integratedSortingColumnExtensions}
                  />
                  <PagingState
                    defaultCurrentPage={0}
                    currentPage={currentPage}
                    onCurrentPageChange={this.changeCurrentPage}
                    pageSize={pageSize}
                    onPageSizeChange={this.changePageSize}
                  />
                  <CustomPaging
                    totalCount={totalCount}
                  />
                  <IntegratedPaging />
                  <Table
                    columnExtensions={tableColumnExtensions}
                  stubRowComponent={StubRow}
                    stubHeaderCellComponent={StubHeader}
                    cellComponent={Cell}
                  />
                  <TableColumnResizing defaultColumnWidths={this.state.tableDetailColumnExtensions} />
                  <TableHeaderRow
                    showSortingControls={true}
                    cellComponent={ColumnHeaderCell}
                  />
                  <TableFilterRow
                  />
                  <TableColumnVisibility
                  />
                  <Toolbar />
                  <SearchPanel />
                  <PagingPanel
                    pageSizes={pageSizes}
                  />
                  <ColumnChooser />
                </Grid>
              </Paper>
            </div>
          </div>
}
        </div>
      </div>
    );
  }
}

// mapping all the recieved prop to local
const mapStateToProps = (state: any) => ({
  AllUsers: state.subscriptionReports.AllUsers,
  Archived: state.subscriptionReports.Archived,
  AllUserNoRR: state.subscriptionReports.AllUserNoRR,
  AllSubscriptions: state.subscriptionReports.AllSubscriptions,
  SubscriptionsByDate: state.subscriptionReports.SubscriptionsByDate,
  ExpiredUsers: state.subscriptionReports.filterExpiredUsers,
  ExpiredIn30Days: state.subscriptionReports.ExpiredIn30Days,
  ExpiredIn120Days: state.subscriptionReports.ExpiredIn120Days,
  AllTSLiveReport: state.subscriptionReports.AllTSLiveReport,
  SpecialBillingReports: state.subscriptionReports.SpecialBillingReports,
  ListOfIrvineAccounts: state.subscriptionReports.ListOfIrvineAccounts,
  ListOfRedyRefAccounts: state.subscriptionReports.ListOfRedyRefAccounts,
  CancelledUsersReport: state.subscriptionReports.CancelledUsersReport,
  loading: state.loading.getsubscriptionReportsStatus
});
export default connect(mapStateToProps)(subscriptionReports);



// WEBPACK FOOTER //
// ./src/components/Subscription/subscriptionReports.tsx